import type { Nullable } from '@iheartjane/types';
import { useContextEnsuringProvider } from '@iheartjane/utils';
import type { PropsWithChildren } from 'react';
import { createContext, useMemo, useState } from 'react';

import type { CartPropertiesCart } from '@jane/kiosk/util';
import type { EmptyCart } from '@jane/shared/types';

type CartInfo = Nullable<{
  birthDate?: Nullable<string>;
  cart: CartPropertiesCart | EmptyCart;
  phoneNumber: Nullable<string>;
  selectedBankAccount: Nullable<string>;
  showPayByLink?: boolean;
  signedInOrder: boolean;
}>;

interface CartInfoForTrackingContext {
  cartInfo: CartInfo;
  setCartInfo: (cartInfo: CartInfo) => void;
}

const CartInfoForTrackingContext =
  createContext<CartInfoForTrackingContext | null>(null);
CartInfoForTrackingContext.displayName = 'CartInfoForTracking';

export const CartInfoForTrackingProvider = ({
  children,
}: PropsWithChildren) => {
  const [cartInfo, setCartInfo] = useState<CartInfo>(null);
  const cartInfoContext = useMemo(
    () => ({ cartInfo, setCartInfo }),
    [cartInfo, setCartInfo]
  );
  return (
    <CartInfoForTrackingContext.Provider value={cartInfoContext}>
      {children}
    </CartInfoForTrackingContext.Provider>
  );
};

export const useCartInfoForTracking = () =>
  useContextEnsuringProvider(CartInfoForTrackingContext);
